import { createExcelAndDownload } from "../../../utils/reportExcelExport";

export function StaffReport(attendance) {
  const customHeadings = [
    { key: "status", label: "Status" },
    { key: "created_at", label: "Time", type: "time" },
    { key: "created_at", label: "Created On", type: "date" },
  ];
  createExcelAndDownload("Staff Attendance Report", attendance, customHeadings);
}
